module.exports = __webpack_public_path__ + "static/media/go__back--white.cae8bc45.svg";